/**
 * Created by imranexpt on 07/04/2016.
 */
(function() {
    /** @ngInject */
    function groupInviteConfirm($scope){
        var card = null;
		var errorElement = null;
        $scope.exp_months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
        var ty = moment().format('YYYY');
        var tyy = _.parseInt(ty)+7;
        var doingPayment = false;
        $scope.exp_years = _.range(ty, tyy);
        if($scope.booking.waitlist == 1){
            $scope.setTemplate('success');
            return;
        };
        $scope.stripeForm = {'number' : '', 'exp-month': '', 'exp-year' : '', 'cvc' : ''};
        $scope.confirmBooking = function(){
            if($scope.booking.status == 2  && $scope.booking.meal.type != 8 && $scope.booking.meal.type != 10 && $scope.booking.meal.type != 9){
                alert("This reservation has been cancelled");
                return false;
            }
        	if(card === null || !card._complete) return false;
            if(doingPayment){
                return false;
            }
            doingPayment = true;
            errorElement = document.getElementById('card-errors');
			//take Intent from server
			$scope.booking.getStripeIntent().then(function(result) {
				handleServerResponse(result.data);
			})
		};


		function handleServerResponse(response) {
			doingPayment = false;
			if (response.error || response.errors) {
				// Show error from server on payment form
				errorElement.textContent = response.error ? response.error : response.errors;
			} else if (response.requires_action) {
				// Use Stripe.js to handle required card action
				doingPayment = true;
				if(response.total > 0) {
					stripe.handleCardPayment(
						response.payment_intent_client_secret, card, {
							payment_method_data: {
								billing_details: {name: $scope.booking.firstname + ' ' + $scope.booking.lastname}
							},
							setup_future_usage: 'off_session'
						}
					).then(function(result) {
						if (result.error) {
							// Display error.message in your UI.
							errorElement.textContent = result.error.message;
							doingPayment = false;
							$scope.$apply();
						} else {
							// The payment has succeeded. Display a success message.
							$scope.booking.saveStripePayment(result.paymentIntent.id).then( function(result){
									handleServerResponse(result);
							})
						}
					});
				} else {
					//store credit card tocken
					stripe.handleCardSetup(
						response.payment_intent_client_secret, card, {
							payment_method_data: {
								billing_details: {name: $scope.booking.firstname + ' ' + $scope.booking.lastname}
							}
						}
					).then(function(result) {
						if (result.error) {
							// Display error.message in your UI.
							errorElement.textContent = result.error.message;
							doingPayment = false;
							$scope.$apply();
						} else {
							// The setup has succeeded. Display a success message.
							$scope.booking.saveStripeCard(result.setupIntent.id).then(function(result){
								handleServerResponse(result);
							})
						}
					});
				}
			} else {
				// Show success
				$scope.setTemplate('success');
				return;
			}
            return false;
        };
        $scope.isDoingPayment = function(){
            return doingPayment;
        };
        window.setTimeout(sendHeightEvent, 800);
        window.setTimeout(initializeStripeForm,200);
        function initializeStripeForm() {
            var elements = stripe.elements();
            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };
            card = elements.create('card', {style: style});
            card.mount('#card-element');
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        }


    }
    angular.module("Waiteraid").controller('groupInviteConfirmCtrl',groupInviteConfirm);
})();
